/**
 * Harvest Monitoring API Service
 * Handles all API calls for harvest monitoring
 */

import api from '../../../auth/apiClient';
import { getHarvestMonitoringEndpoint } from '../apiConfig';
import type { HarvestMonitoringResponse, HarvestMonitoringFilters, SPBReportResponse } from '../types';

export class HarvestMonitoringApiService {
    /**
     * Fetch harvest monitoring data
     */
    static async getMonitoring(filters: HarvestMonitoringFilters): Promise<HarvestMonitoringResponse> {
        const endpoint = getHarvestMonitoringEndpoint('MONITORING');

        // Remove allowed_divisions as it's for legacy FE filtering; range endpoint takes start/end only
        const { allowed_divisions, current_date, ...apiParams } = filters;

        const response = await api.get<HarvestMonitoringResponse>(endpoint, {
            params: apiParams,
        });
        console.log('API Response:', response.data); // Debug log
        return response.data;
    }

    /**
     * Fetch harvest monitoring SPB data
     */
    static async getMonitoringSPB(filters: HarvestMonitoringFilters): Promise<SPBReportResponse> {
        const endpoint = getHarvestMonitoringEndpoint('MONITORING_SPB');

        // Remove allowed_divisions as it's for legacy FE filtering; range endpoint takes start/end only
        const { allowed_divisions, current_date, ...apiParams } = filters;

        const response = await api.get<SPBReportResponse>(endpoint, {
            params: apiParams,
        });
        console.log('API SPB Response:', response.data); // Debug log
        return response.data;
    }
}
